module.exports = __webpack_public_path__ + "img/24.6fe19dd4.png";